import type { Channel } from '@/types/channel';

export type HealthColor = 'green' | 'red' | 'gray';

export function computeHealthColor(channel: Channel): HealthColor {
  // Gray takes priority — user disabled forwarding
  if (!channel.forwardingEnabled) return 'gray';

  const isCoexistence = channel.connectionType === 'coexistence';

  // RED reflects Meta quality LOW only (WhatsApp-only concept). Destination-
  // availability is no longer a health signal: the HookMyApp CLI is the
  // conceptual default destination, so "no webhook URL + no active CLI tunnel
  // right now" is just the default state, not a warning. Meta quality MEDIUM
  // is rolled into GREEN — only outright LOW surfaces as RED.
  if (!isCoexistence && channel.type === 'whatsapp' && channel.whatsappQualityRating === 'RED') return 'red';

  return 'green';
}

const healthColorMap = {
  gray: 'bg-neutral-400',
  green: 'bg-emerald-500',
  red: 'bg-red-500',
} as const;

export function healthDotClass(channel: Channel): string {
  return healthColorMap[computeHealthColor(channel)];
}

export function healthTooltip(channel: Channel): string {
  const isCoexistence = channel.connectionType === 'coexistence';

  if (!channel.forwardingEnabled) return 'Messaging disabled';
  if (!isCoexistence && channel.type === 'whatsapp' && channel.whatsappQualityRating === 'RED') return 'Meta quality rating: Low';
  return 'Healthy';
}

